import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router';

import { useAppDispatch } from 'app/hooks';
import { logout } from 'features/auth/authSlice';

export function UserLogoutLink(props: { className?: string }) {
  const { className } = props;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  async function handleClick() {
    // Dispatch logout (this clears token and sets status to anonymous)
    await dispatch(logout());

    // Navigate to home (which will redirect to welcome for anonymous users)
    navigate('/');
  }

  return (
    <div onClick={handleClick} className={classNames(className)}>
      <FormattedMessage id="NAVIGATION.LOGOUT" />
    </div>
  );
}
